// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input.mat-chip-input {
  width: 100%;
}

.icon-help {
  font-size: 18px;
  margin: 0 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/bags/bag-transation-form/bag-transation-form.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ","sourcesContent":["input.mat-chip-input {\n    width: 100%;\n}\n\n.icon-help{\n    font-size: 18px;\n    margin: 0 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
